import { createBrowserInspector } from '@statelyai/inspect';
import { createActorContext } from '@xstate/react';

import { transcriptionMachine } from '@eluve/frontend-machine-common';

const getInspect = () => {
  if (process.env.NODE_ENV !== 'development') {
    return undefined;
  }

  const IgnoredInspectorEvents: string[] = [];
  const { inspect } = createBrowserInspector({
    autoStart: false,
    filter: (inspEvent) => {
      if (inspEvent.type === '@xstate.event') {
        return !IgnoredInspectorEvents.includes(inspEvent.event.type);
      }
      if (inspEvent.type === '@xstate.snapshot') {
        return !IgnoredInspectorEvents.includes(inspEvent.event.type);
      }
      return true;
    },
  });

  return inspect;
};

export const TranscriptionMachineContext = createActorContext(
  transcriptionMachine,
  {
    inspect: getInspect(),
  },
);

export const useTranscriptionMachineSelector =
  TranscriptionMachineContext.useSelector;

export const useTranscriptionMachineActor =
  TranscriptionMachineContext.useActorRef;
